export default __webpack_public_path__ + "static/media/MusicH4.340d56ef.png";